import React from "react";
import { Navigate, useRoutes } from "react-router-dom";
import MatxLayout from "./maxtLayout.js/maxtLayout";
import Dashboard from "./pages/dashboard/Dashboard";
import Categories from "./pages/categories/Categories";
import AddCategory from "./pages/add-category/addCategory";
import Image from "./pages/images/Image";
import AddImage from "./pages/add-images/AddImages";
import AddMultiImages from "./pages/add-multi-images/AddMultiImages";
import AddMultiHDRImages from "./pages/multi-hdr";
import Parallax from "./pages/parallax/Parallax";
import MultiParallax from "./pages/multi-parallax/multiParallax";
import Login from "./components/login/Login";
import Wallpaper from "./pages/add-wallpaper/add-wallpaper";
import MultiWallpaper from "./pages/multi-wallpapers/multi-wallpappers";
import Wallpaper3D from "./pages/3Dwallpaper/add-3Dwallpaper";
import MultiWallpaper3D from "./pages/3Dmultiwallpaper/add-multi3Dwallpaper";
import AddHDRImages from "./pages/hdr";
import Collections from "./pages/collections/Collections";
import AddCollection from "./pages/add-collection/addCollection";
import LiveClock from "./pages/live-clock/LiveClock";
import Fonts from "./pages/fonts/Fonts";

function RedirectionWrapper({ to }) {
  const queryString = window.location.search;
  if (queryString) {
    return <Navigate to={`${to}${queryString}`} />;
  }
  return <Navigate to={to} />;
}

const routes = (isLoggedIn) => [
  {
    path: "/",
    element: isLoggedIn ? <MatxLayout /> : <RedirectionWrapper to="/login" />,
    children: [
      {
        index: true,
        element: <RedirectionWrapper to="/dashboard" />,
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
      },
      {
        path: "/categories",
        element: <Categories />,
      },
      {
        path: "/add-categories",
        element: <AddCategory />,
      },
      {
        path: "/collections",
        element: <Collections />,
      },
      {
        path: "/add-collections",
        element: <AddCollection />,
      },
      {
        path: "/images",
        element: <Image />,
      },
      {
        path: "/add-images",
        element: <AddImage />,
      },
      // {
      //   path: "/add-hdr-images",
      //   element: <AddHDRImages />,
      // },
      {
        path: "/add-multi-images",
        element: <AddMultiImages />,
      },
      // {
      //   path: "/add-multi-hdr-images",
      //   element: <AddMultiHDRImages />,
      // },
      {
        path: "/parallax",
        element: <Parallax />,
      },
      {
        path: "/multi-parallax",
        element: <MultiParallax />,
      },
      {
        path: "/wallpaper",
        element: <Wallpaper />,
      },
      {
        path: "/multi-wallpaper",
        element: <MultiWallpaper />,
      },
      {
        path: "/3d-wallpaper",
        element: <Wallpaper3D />,
      },
      {
        path: "/multi-3d-wallpaper",
        element: <MultiWallpaper3D />,
      },
      {
        path: "/live-clock",
        element: <LiveClock />,
      },
      {
        path: "/fonts",
        element: <Fonts />,
      },
    ],
  },
  {
    path: "/login",
    element: !isLoggedIn ? <Login /> : <RedirectionWrapper to="/dashboard" />,
  },
];

export default function Routes(props) {
  const { isLoggedIn } = props;
  return useRoutes(routes(isLoggedIn));
}
